function detect_visibility_yotpo(selector){
    console.log("selector",selector);
    // var top_of_element = $(selector).offset().top;
    // var bottom_of_element = $(selector).offset().top + $(selector).outerHeight();
    // var bottom_of_screen = $(window).scrollTop() + $(window).innerHeight();
    // var top_of_screen = $(window).scrollTop();

    // const scriptsLoadedYotpo = $('.yotpo-script').length > 0;

    // if ((bottom_of_screen > top_of_element) && (top_of_screen < bottom_of_element) && scriptsLoadedYotpo === false){
    //   // Load Yotpo reviews script when featured collections are visible
    //   $('head').append('<script class="yotpo-script" src="https://cdn-widgetsrepository.yotpo.com/v1/loader/K56-hRUCNEgQ7eSdgVrZ4A" async></script>');
    //   $('body').append('<script class="yotpo-script" type="text/javascript">(function e(){var e=document.createElement("script");e.type="text/javascript",e.async=true,e.src="//staticw2.yotpo.com/RcALBQr2HLnuiNuP0osvNQpRRLcCnRJC88aDWprC/widget.js";var t=document.getElementsByTagName("script")[0];t.parentNode.insertBefore(e,t)})();</script>');
    //   console.log('loading');
    //   scriptsLoaded = true;
    // } else {

    // }
}


function detect_visibility_pagelist(selector){
    console.log("selector",selector);
    // var top_of_element = selector.offset().top;
    // console.log("hsj",top_of_element);
    // var bottom_of_element = $(selector).offset().top + $(selector).outerHeight();
    // var bottom_of_screen = $(window).scrollTop() + $(window).innerHeight();
    // var top_of_screen = $(window).scrollTop();

    // if ((bottom_of_screen > top_of_element) && (top_of_screen < bottom_of_element)){
      // $(selector).each((index, element) => {
        // const background = $(element).data('background-image');
        // $(element).css('background-image', `url(${background})`);
      // });
    // } else {

    // }
}

// detect when element gets visible on scroll
  if (window.location.href === '/pages/') {
    // $(window).scroll(function() {
    detect_visibility_yotpo("hiii");
// });
    // $(window).scroll(function() {
    detect_visibility_pagelist('ppp');
// });
    // detect when screen opens for first time
      detect_visibility_yotpo('jooo');
      detect_visibility_pagelist('kkkk');
    }
// });